import axios from 'axios';
import { setPriceCodeSettings } from './utils/priceCode';

const isProduction = window.location.hostname !== 'localhost';
const BASE_URL = isProduction 
  ? 'https://billsaas-uncle-backend.onrender.com/api'
  : 'http://localhost:5000/api';

const API = axios.create({
  baseURL: BASE_URL,
});

API.interceptors.request.use((req) => {
  const token = localStorage.getItem('token');
  if (token) {
    req.headers.Authorization = `Bearer ${token}`;
  }
  return req;
});

API.interceptors.response.use(
  (res) => res,
  (err) => {
    if (err.response?.status === 401) {
      localStorage.removeItem('token');
      localStorage.removeItem('user');
      localStorage.removeItem('shopProfile');
      localStorage.removeItem('priceCodeSettings');
      window.location.href = '/';
    }
    return Promise.reject(err);
  }
);

export default API;